export const UC_PROCEDURES = 'procedures';
export const UC_ARCHIVEDPROCEDURES = 'archived-procedure';
export const UC_DASHBOARD = 'dashboard';
export const UC_ALD_OPERATOR = 'ald';
export const UC_SP_OPERATOR = 'sp';
export const UC_APPOINTMENTS = 'appointments';
export const UC_SIGN = 'digital-sign';
export const UC_PAPER_SIGN = 'sign-paper';
export const UC_PAPER_SIGN_END = 'sign-paper-end';
export const UC_APPOINTMENT_READ = 'read';


